import { render, staticRenderFns } from "./ListSoftwaresCriticalSection.vue?vue&type=template&id=34fc7c4c&scoped=true&"
import script from "./ListSoftwaresCriticalSection.vue?vue&type=script&lang=js&"
export * from "./ListSoftwaresCriticalSection.vue?vue&type=script&lang=js&"
import style0 from "./ListSoftwaresCriticalSection.vue?vue&type=style&index=0&id=34fc7c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fc7c4c",
  null
  
)

export default component.exports